// Whether the riichi button should be offered on the human's turn. The engine (declareRiichi) already
// honors 点棒なし立直 (riichiBelowStick: declare even when score < the stick) and 再立直 (reRiichi:
// declare AGAIN while already in riichi) — but the play-surface gate used to hard-require
// `score >= riichiStick` and `!alreadyDeclared`, so with those flags ON the button never appeared
// ("無限立直が実装されていない"). This pure helper mirrors the engine's gates so the UI matches.
export function riichiAvailable(a: {
  onTurn: boolean;
  menzen: boolean;
  declared: boolean;
  tenpaiReachable: boolean; // a discard that reaches tenpai exists
  score: number;
  riichiStick: number;
  riichiBelowStick: boolean;
  reRiichi: boolean;
}): boolean {
  if (!a.onTurn || !a.menzen || !a.tenpaiReachable) return false;
  // already in riichi: only 再立直 lets you re-declare.
  if (a.declared && !a.reRiichi) return false;
  // need the stick unless 点棒なし立直 is on (then score may go negative — intended).
  if (!a.riichiBelowStick && a.score < a.riichiStick) return false;
  return true;
}
